import Vue from 'vue'
import App from './App.vue'

import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// Ready translated locale messages
const messages = {
  en: {
    message: {
      aboutMe: {
        link: 'About me',
        head: 'About Me',
        strongText: 'Out of passion I develop software that is tailored to the requirements of the customer.',
        description: 'My strengths in software development include conception of software architecture, backend development, optimization of runtime speed and finding errors in code. The application of principles such as Clean Code and DRY are a matter of course.'
      },
      resume: {link: 'Resume', head: 'View My Resume',
        stations: [
          {
            head: 'Software Engineer Medical Technology (2019-2020)',
            content: `<p>Further development of a medical device (embedded):
                        <ul>
                          <li>Creation of new releases for the product</li>
                          <li>Concept for connecting the device to the cloud</li>
                          <li>Concept and implementation of a library for basic calculations used by different devices</li>
                        </ul>
                      </p>`
          },
          {
            head: 'Software Developer Aviation (2013–2019)',
            content: `<p>Maintenance and extension of two document management systems for a large German airline:
                        <ul>
                          <li>Aircraft documentation, in which all maintenance logs and documents of an aircraft are stored.</li>
                          <li>Management of the entire technical manufacturer documentation of aircraft, from engines to coffee machines</li>
                        </ul>
                      </p>`
          },
          {
            head: 'B.Sc. Computing in Science',
            content: `<p>Best in his year, special modules:
                        <ul>
                          <li>Data visualization and GPU computing</li>
                          <li>High Performance Computing</li>
                        </ul>
                      </p>`
            /* content: `<p>Während des Physik-Studiums merkte er, dass es ein Problem in der praktischen Physik gibt, man findet selten exakte Lösungen, sondern in der Regel nur Näherungen und kann so gut wie immer noch eine genauere Lösung finden.<br>Da man in der Informatik mit weniger Näherungen auskommt, hat er sich entschieden an der Universität Hamburg Computing in Science zu studieren und schloss sein Studium mit der Note 1,62 ab.</p>` */
          },
          {
            head: 'B.Sc. Physics',
            content: `<p>Focus:
                        <ul>
                          <li>Experimental Physics AFM</li>
                        </ul>
                      </p>`
          },
          {
            head: 'Year abroad in Peru',
            content: `<ul>
                        <li>Spanish fluent</li>
                      </ul>`
          },
          {
            head: 'Abitur',
            content: `<p>Advanced courses:
                        <ul>
                          <li>Mathematics</li>
                          <li>Physics</li>
                        </ul>
                      </p>`
          }
        ],
        footerText: 'Further information can be provided upon request.'
      },
      services: {
        link: 'Services',
        head: 'Services',
        description: 'A selection of offered services.',
        services: [
          {name: "Creation of software architectures", icon: "cogs fas"},
          {name: "Interfaces to external systems as i.e. SAP, Filenet, IBM Datacap", icon: "squarespace fab"},
          {name: "Software development", icon: "code fas"},
          {name: "Optimization of database queries", icon: "rocket fas"},
          {name: "Database modelling", icon: "paint-brush fas"},
          {name: "Database migration", icon: "directions fas"},
          {name: "Webservices", icon: "upload fas"},
          {name: "Refactoring of legacy code", icon: "meteor fas"},
          {name: "Fulltext search with Lucene", icon: "search fas"},
        ]
      },
      skills: {
        link: 'Skills',
        head: 'Skills',
        skills_by_topic: [
          {topic: "Backend", skills: [
            {
              area: "Java",
              value: 95,
              explanation: `In the backend area in Tomcat environment for document management, also for desktop application for displaying documents`
            },
            {
              area: "C++",
              value: 90,
              explanation: `In the backend area with Tntnet framework and later Beast framework,
              embedded device in the medical field,
              extension of a library to read the proxy settings in Internet Explorer`
            },
            {
              area: "C#",
              value: 80,
              explanation: `Embedded device in the medical field, for desktop application for metadata capture of documents with integrated OCR, document conversion tool for converting Office documents to PDF`
            },
            {
              area: "Python",
              value: 80,
              explanation: 'For tool for generating C++ code using template files and tool to recognize QR-Codes from photos for photo ordering'
            },
            {
              area: "Rust",
              value: 70,
              explanation: 'In the backend area to replace C++'
            },
            {
              area: "PHP",
              value: 70,
              explanation: 'With Drupal and other projects'
            }
          ]},
          {topic: "Databases", skills: [
            {
              area: "OracleDB",
              value: 95,
              explanation: `For document management system in aviation`
            },
            {
              area: "PostgreSQL",
              value: 90,
              explanation: 'For backend application in combination with Rust/C++'
            },
            {
              area: "MySQL",
              value: 80,
              explanation: 'For Drupal and Wordpress'
            },
            {
              area: "SQLite",
              value: 80,
              explanation: 'For local data storage in a Windows Mobile app'
            },
          ]},
          {topic: "Frontend", skills: [
            {area: "HTML", value: 95},
            {area: "Javascript", value: 95},
            {area: "CSS", value: 90},
            {
              area: "VueJS",
              value: 80,
              explanation: 'For this Homepage'
            },
            {
              area: "Bootstrap",
              value: 75,
              explanation: 'For frontend of the C++ backend'
            },
            {
              area: "Bulma",
              value: 75,
              explanation: 'For this Homepage'
            }
          ]},
          {topic: "Other", skills: [
            {
              area: "Eclipse",
              value: 95,
              explanation: 'For Java development'
            },
            {
              area: "Microsoft Visual Studio",
              value: 90,
              explanation: 'For C# development'
            },
            {area: "Git", value: 80},
            {area: "SVN", value: 80},
            {
              area: "Jitsi Meet Video Conference Server",
              value: 80,
              explanation: 'Installation of own servers with fixed network dial-in'
            },
            {
              area: "IntelliJ IDEA",
              value: 70,
              explanation: 'For Rust development'
            },
            {
              area: "Jenkins",
              value: 70,
              explanation: 'For Continuous Integration and Build Automation'
            },
            {
              area: "Datalogics PDF library",
              value: 70,
              explanation: 'For reading and converting PDF files'
            },
            {
              area: "Prosody XMPP Server",
              value: 70,
              explanation: 'When used with Conversations as instant messaging client'
            },
            {
              area: "Jira",
              value: 70,
              explanation: 'Used for customer requirements specification, estimation and tracking process'
            },
            {
              area: "Confluence",
              value: 70,
              explanation: 'Used for documentation'
            },
          ]}
        ]
      },
      experiences: {
        link: 'Expert Knowledge',
        head: 'Expert Knowledge',
        years: ' | {n} year | {n} years'
      },
      contact: {
        link: 'Contact',
        head: 'Get in touch',
        orderRequest: 'Order request',
        otherRequest: 'Other',
        nameLabel: 'Name',
        namePlaceholder: 'Ex. Ashley Craft',
        emailLabel: 'Email',
        emailPlaceholder: 'Ex. ashley@craft.com',
        startDateLabel: 'Start of work',
        startDatePlaceholder: '(multiple dates selectable)',
        durationLabel: 'Duration of work',
        durationPlaceholder: '(Duration in months)',
        workloadLabel: 'Workload',
        workloadPlaceholder: '(Percentage of workload)',
        locationLabel: 'Work location',
        locationPlaceholder: 'Postcode of work location',
        remoteCheckbox: {onSite: "On site", remote: "Remote"},
        hourRateLabel: 'Hour rate',
        hourRatePlaceholder: '(Hour rate in Euro)',
        getToKnowLabel: 'How did you know about me?',
        getToKnowPlaceholder: 'Please select one item',
        getToKnowOptions: [
          {value: "mail", description: "Mail"},
          {value: "friend", description: "Friend"},
          {value: "xing", description: "Xing"},
          {value: "expertLead", description: "Expertlead"},
          {value: "gulp", description: "Gulp"},
          {value: "google", description: "Google"},
          {value: "other", description: "Other"},
        ],
        getToKnowOtherPlaceholder: 'Please enter here how did you know about me',
        orderMessageLabel: "Details of your project",
        messageLabel: "Message",
        messagePlaceholder: 'Your message',
        submitBtnTxt: "Submit",
        successfulSentMsg: "Your message was sent successfully.",
        serverNotAnsweredAsExpected: "Your message cannot be sent at the moment.",

        monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        dayNames: ["Su", "M", "Tu", "W", "Th", "F", "S"]
      }
    }
  },
  de: {
    message: {
      aboutMe: {link: 'Über mich', head: 'Über mich',
        strongText: 'Aus Leidenschaft entwickle ich Software, die auf die Anfor&shy;derungen des Kunden abgestimmt ist.',
        description: 'Meine Stärken in der Softwareentwicklung liegen unter anderem in der Konzeption von Softwarearchitekturen, der Backend-Entwicklung, Optimierung von Laufzeit&shy;geschwindigkeit und dem Auffinden von Fehlern im Code. Die Anwendung von Prinzipien wie z.B. Clean Code und DRY sind selbstverständlich.'
      },
      resume: {link: 'Lebenslauf', head: 'Lebenslauf',
        stations: [
          {
            head: 'Softwareingenieur Medizintechnik (2019-2020)',
            content: `<p>Weiterentwicklung eines medizinischen Gerätes (embedded):
                        <ul>
                          <li>Erstellung neuer Releases für das Produkt</li>
                          <li>Konzept für die Anbindung des Gerätes an die Cloud</li>
                          <li>Konzept und Umsetzung einer Bibliothek für grundlegende Berechnungen, die von verschiedenen Geräten verwendet werden</li>
                        </ul>
                      </p>`
          },
          {
            head: 'Softwareentwickler Luftfahrt (2013–2019)',
            content: `<p>Pflege und Erweiterung zweier Dokumenten&shy;verwaltungs&shy;systeme für große deutsche Airline:
                        <ul>
                          <li>Flugzeugdokumentation, in der alle Wartungsprotokolle und Dokumente eines Flugzeugs abgelegt werden.</li>
                          <li>Verwaltung der gesamten technischen Herstellerdokumentation von Flugzeugen, vom Triebwerk bis zur Kaffeemaschine</li>
                        </ul>
                      </p>`
          },
          {
            head: 'B.Sc. Computing in Science',
            content: `<p>Jahrgangsbester, besondere Module:
                        <ul>
                          <li>Datenvisualisierung und GPU-Computing</li>
                          <li>Hochleistungsrechnen</li>
                        </ul>
                      </p>`
            /* content: `<p>Während des Physik-Studiums merkte er, dass es ein Problem in der praktischen Physik gibt, man findet selten exakte Lösungen, sondern in der Regel nur Näherungen und kann so gut wie immer noch eine genauere Lösung finden.<br>Da man in der Informatik mit weniger Näherungen auskommt, hat er sich entschieden an der Universität Hamburg Computing in Science zu studieren und schloss sein Studium mit der Note 1,62 ab.</p>` */
          },
          {
            head: 'B.Sc. Physics',
            content: `<p>Schwerpunkt:
                        <ul>
                          <li>Experimentalphysik AFM</li>
                        </ul>
                      </p>`
          },
          {
            head: 'Auslandsjahr in Peru',
            content: `<ul>
                        <li>Spanisch fließend</li>
                      </ul>`
          },
          {
            head: 'Abitur',
            content: `<p>Leistungskurse:
                        <ul>
                          <li>Mathematik</li>
                          <li>Physik</li>
                        </ul>
                      </p>`
          }
      /*    ,{
            head: 'Grundschule',
            content: `<p>Schon im Grundschulalter entdeckte er seine Leidenschaft für Computer und entwickelte seine ersten Programme mit QBasic. Seine erste Homepage stellte er dann mit 10 Jahren online. Da statische Seiten schnell zu langweilig wurden, musste etwas dynamisches her und er fing mit PHP an, um automatisiert Musikvideos herunterzuladen.</p>`
          } */
        ],
        footerText: 'Weitere Informationen können auf Anfrage zur Verfügung gestellt werden.'
      },
      services: {
        link: 'Leistungen',
        head: 'Leistungen',
        description: 'Unten finden Sie eine Auswahl der angebotenen Leistungen.',
        services: [
          {name: "Erstellung von Softwarearchitekturen", icon: "cogs fas"},
          {name: "Schnittstellen zu Fremdsystemen wie SAP, Filenet, IBM Datacap", icon: "squarespace fab"},
          {name: "Softwareentwicklung", icon: "code fas"},
          {name: "Optimierung von Datenbankabfragen", icon: "rocket fas"},
          {name: "Datenbankmodellierung", icon: "paint-brush fas"},
          {name: "Datenbankmigration", icon: "directions fas"},
          {name: "Webservices", icon: "upload fas"},
          {name: "Refactoring von Legacy-Code", icon: "meteor fas"},
          {name: "Volltextsuche mit Lucene", icon: "search fas"},
        ]
      },
      skills: {
        link: 'Skills',
        head: 'Skills',
        skills_by_topic: [
          {topic: "Backend", skills: [
            {
              area: "Java",
              value: 95,
              explanation: `Im Backendbereich in Tomcat-Umgebung für Dokumentenverwaltung, außerdem für Desktop-Anwendung zur Anzeige von Dokumenten`
            },
            {
              area: "C++",
              value: 90,
              explanation: `Im Backendbereich mit Tntnet-Framework und später Beast-Framework,
              Embedded Gerät im medizinischen Bereich,
              Erweiterung einer Bibliothek zum Auslesen der Proxy-Einstellungen im Internet Explorer`
            },
            {
              area: "C#",
              value: 80,
              explanation: `Embedded Gerät im medizinischen Bereich, für Desktop-Anwendung zur Metadatenerfassung von Dokumenten mit integrierter OCR, Dokumentkonvertierungstool zur Umwandlung von Office-Dokumenten nach PDF`
            },
            {
              area: "Python",
              value: 80,
              explanation: 'Für Tool zur Generierung von C++-Code mittels Template-Dateien und Tool zum Erkennen von QR-Codes auf Fotos zur Fotosortierung'
            },
            {
              area: "Rust",
              value: 70,
              explanation: 'Im Backend-Bereich zur Ablösung von C++'
            },
            {
              area: "PHP",
              value: 70,
              explanation: 'Mit Drupal und anderen Projekten'
            }
          ]},
          {topic: "Databases", skills: [
            {
              area: "OracleDB",
              value: 95,
              explanation: `Für Dokumentenverwaltungssystem in der Luftfahrt`
            },
            {
              area: "PostgreSQL",
              value: 90,
              explanation: 'Für Backendanwendung in Zusammenspiel mit Rust/C++'
            },
            {
              area: "MySQL",
              value: 80,
              explanation: 'Für Drupal und Wordpress'
            },
            {
              area: "SQLite",
              value: 80,
              explanation: 'Für die lokale Datenspeicherung in einer Windows Mobile App'
            },
          ]},
          {topic: "Frontend", skills: [
            {area: "HTML", value: 95},
            {area: "Javascript", value: 95},
            {area: "CSS", value: 90},
            {
              area: "VueJS",
              value: 80,
              explanation: 'Für diese Homepage'
            },
            {
              area: "Bootstrap",
              value: 75,
              explanation: 'Für Frontend des C++ Backends'
            },
            {
              area: "Bulma",
              value: 75,
              explanation: 'Für diese Homepage'
            }
          ]},
          {topic: "Other", skills: [
            {
              area: "Eclipse",
              value: 95,
              explanation: 'Für Java-Entwicklung'
            },
            {
              area: "Microsoft Visual Studio",
              value: 90,
              explanation: 'Für C# Entwicklung'
            },
            {area: "Git", value: 80},
            {area: "SVN", value: 80},
            {
              area: "Jitsi Meet Video Conference Server",
              value: 80,
              explanation: 'Installation eigenen Servers mit Festnetzeinwahl'
            },
            {
              area: "IntelliJ IDEA",
              value: 70,
              explanation: 'Für Rust Entwicklung'
            },
            {
              area: "Jenkins",
              value: 70,
              explanation: 'Für Continuous Integration und Build Automation'
            },
            {
              area: "Datalogics PDF library",
              value: 70,
              explanation: 'Für das Auslesen und Konvertieren von PDF Dateien'
            },
            {
              area: "Prosody XMPP Server",
              value: 70,
              explanation: 'In Verwendung mit Conversations als Instant-Messaging-Client'
            },
            {
              area: "Jira",
              value: 70,
              explanation: 'Verwendet für Spezifizierung der Anforderung auf Kundenseite, Umsetzungsbeschreibgung, Schätzung and Ablaufverfolgung'
            },
            {
              area: "Confluence",
              value: 70,
              explanation: 'Für Dokumentation verwendet'
            },
          ]}
        ]
      },
      experiences: {
        link: 'Erfahrung',
        head: 'Erfahrung',
        years: ' | {n} Jahr | {n} Jahre'
      },
      contact: {
        link: 'Kontakt',
        head: 'Kontakt aufnehmen',
        orderRequest: 'Auftragsanfrage',
        otherRequest: 'Sonstiges',
        nameLabel: 'Name',
        namePlaceholder: 'Max Mustermann',
        emailLabel: 'Email',
        emailPlaceholder: 'max@mustermann.de',
        startDateLabel: 'Arbeitsbeginn',
        startDatePlaceholder: '(mehrere Daten auswählbar)',
        durationLabel: 'Dauer des Auftrags',
        durationPlaceholder: '(Dauer in Monaten)',
        workloadLabel: 'Auslastung',
        workloadPlaceholder: '(Auslastung in Prozent)',
        locationLabel: 'Ausführungsort',
        locationPlaceholder: 'Postleitzahl des Ausführungsortes',
        remoteCheckbox: {onSite: "Vor Ort", remote: "Remote"},
        hourRateLabel: 'Stundensatz',
        hourRatePlaceholder: '(Stundensatz in Euro)',
        getToKnowLabel: 'Wie sind Sie auf mich aufmerksam geworden?',
        getToKnowPlaceholder: 'Bitte auswählen',
        getToKnowOptions: [
          {value: "mail", description: "Email"},
          {value: "friend", description: "Freund"},
          {value: "xing", description: "Xing"},
          {value: "expertLead", description: "Expertlead"},
          {value: "gulp", description: "Gulp"},
          {value: "google", description: "Google"},
          {value: "other", description: "Sonstige"},
        ],
        getToKnowOtherPlaceholder: 'Wie haben Sie mich gefunden?',
        orderMessageLabel: "Details zum Auftrag",
        messageLabel: "Nachricht",
        messagePlaceholder: 'Ihre Nachricht',
        submitBtnTxt: "Abschicken",
        successfulSentMsg: "Ihre Nachricht wurde erfolgreich abgeschickt.",
        serverNotAnsweredAsExpected: "Ihre Nachricht kann gerade nicht versendet werden.",
        serverNotAvailable: "Ihre Nachricht kann gerade nicht versendet werden.",
        connectionError: "Es kann gerade keine Verbindung zum Server aufgebaut werden.",

        monthNames: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
        dayNames: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"]
      }
    }
  }
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'de', // set locale
  messages, // set locale messages
})


Vue.config.productionTip = false

new Vue({
  i18n,
  render: h => h(App),
}).$mount('#app')
